export enum documentType {
  CONTRACT = 5,
  INVOICE = 2,
  PAYMENT = 3,
  TUITION=1,
  ACCOMMODATION=2,
  MEALS=3,
  OTHER=4,
}

export enum StudentDocumentLabel {
  MATRIC_CERTIFICATE = 'Matric Certificate',
  ACADEMIC_RECORD = 'Academic Record',
  PROOF_OF_IDENTIFICATION = 'Proof of Identification',
  FINANCIAL_STATEMENT = 'Financial Statement',
}
